import { DonorStatus } from 'gql/types';

const STATUS_DISPLAY_NAMES: Record<string, string> = {
  Active: 'Active',
  Approved: 'Approved',
  AnnualLabworkDue: 'Annual Labwork Due',
  Pending: 'Pending',
  Retired: 'Retired',
  Archived: 'Archived',
  LabworkPending: 'Labwork Pending',
  NotAccepted: 'Not Accepted',
  Affiliate: 'Affiliate',
};

export function formatActiveStatuses(statuses?: DonorStatus[]): string {
  if (!statuses?.length) return 'Active, Annual Labwork Due';
  return statuses.map((s) => STATUS_DISPLAY_NAMES[s] || s).join(', ');
}
